<template>
  <div>
    <!-- DEV -->
      <!-- <h1>Receipts Interface</h1> -->
    <!--  -->

    
    <div data-dev-group="title_header" >
      <h6>Receipts Interface</h6>
    </div>

    <!-- Main Div -->
    <div class="main-div">
      <div class="receipt-number-div">
        <p>Example Receipt Number: I1001-4465330</p>
        
        <input 
          v-model="store.receiptNumber" 
          @keyup.enter="store.getData()" 
          type="text" 
          placeholder="Receipt Number" 
        />
        <button @click="store.getData()">Get Receipt</button>
      </div>
      
      <!-- Receipt Data Debug Div -->
      <!--
      <div class="receipt-data-debug-div">
        {{ store.receipts.length > 0 ? store.receipts[0] : 'No receipt data' }}
      </div>
      -->
      <!-- End of Receipt Data Debug Div -->
      
      <!-- Receipt Data Entry Div -->
      <div class="receipt-data-entry-div">
        <div v-if="store.receipts.length > 0">  
          <!-- { "DateTime": "2024-07-31T23:03:15.000Z", "Invoice_Number": "4465330", "Grand_Total": -199.27, "data_array": [ "1", "867999" ] } -->
          <p>Invoice Number: {{ store.receipts[0].Invoice_Number }}</p>
          <p>Date: {{ D(store.receipts[0].DateTime) }}</p>
          <p>Amount: {{ F(store.receipts[0].Grand_Total) }}</p>
          <select v-model="store.receipts[0].data_array[0]">
            <option v-for="key in Object.keys(companyNames)" :key="key" :value="key">{{ companyNames[key] }}</option>
          </select>
          <input 
            v-model="store.receipts[0].data_array[1]" 
            @keyup.enter="saveReceipt()" 
            type="text" 
            placeholder="Plate Number"  
          />

          <button @click="saveReceipt()">Save Receipt</button>
        </div>
        <div v-else>
          <p>No receipt data</p>
        </div>
        
      </div>
      <!-- End of Receipt Data Entry Div -->
    </div>
    <!-- End of Main Div  -->
    
    
  </div>
</template>

<script>
import formatDataMixin from '../../../../mixins/formatDataMixin';
export default {
  name:'ReceiptInterface',
  mixins:[formatDataMixin],
  inject:['page'],
  // props:['storeName'],
  props:{
    storeName:{type:String},
    selectedTimePeriod:{default:'day'},
  },
  data(){
    return {
      // tmp home
      selectedDepartment: 'all',
      // end of tmp home

      meta:{
        dow:false,
        // showDetails: false,
      },
    }
  },
  mounted(){
  },
  computed:{
    store(){return this.page.$refs[this.storeName ? this.storeName : 'receiptsStore']},
    // chargeAccountStore(){return this.page.$refs['chargeAccountStore']},
    companyNames(){return this.$chargeAccountCompanyNames},
    departments(){return this.store.deptKeys},
    filteredList(){return this.selectedDepartment !== 'all' ? this.$util.filterArrayForKeyValue(this.store.dataArray, 'Dept_ID', this.selectedDepartment) : this.store.dataArray},
    // selectedTransactions(){return this.$util.sortAscForKeyPath(this.store.selectedTransactions, 'DateTime', false)},
    // keys(){return Object.keys(this.store[`${this.selectedTimePeriod}Transactions`]).sort().reverse()},
    // timestamps(){ return this.store.timestamps},
    // dateKey(){ return this.timestamps.dateKey},
  },
  methods:{
    saveReceipt(){
      this.store.saveReceipt(this.store.receipts[0], ()=>{
        this.page.$refs['monthlyChargesStore'].getData();
      })
    }
  }
}
</script>

<style>

.topSalesTable {
  width: 850px;
}
.topSalesTable td {
  white-space: nowrap;
  max-width: 250px;
  min-width: 10px;
  overflow: visible;
  padding-left:10px;
}

.topSalesTable th:nth-child(3n+3){
  padding-right: 20px;
}

.topSalesTable td:nth-child(3n+3){
  padding-right: 20px;
}
</style>